import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { KycUploadButton } from './KycUploadButton';

const TIPS = [
  { img: 'tip-1.png', icon: 'icon-correct.png', text: <>Words &amp; images are clear<br />without reflection</> },
  { img: 'tip-2.png', icon: 'icon-wrong.png', text: 'Blur image' },
  { img: 'tip-3.png', icon: 'icon-wrong.png', text: 'Image with light reflection' },
];

const TipCard = ({ img, icon, text }) => (
  <div className="flex flex-col items-center text-center">
    <div className="relative w-full aspect-[188/127]">
      <img src={`/images/kyc/${img}`} alt="" className="w-full h-full object-cover" />
      <img src={`/images/kyc/${icon}`} alt="" className="absolute -top-2.5 -right-2.5 w-6 h-6 sm:w-[26px] sm:h-[26px]" />
    </div>
    <p className="text-[12px] sm:text-[14px] mt-2.5 leading-snug">{text}</p>
  </div>
);

export const KycStepTwo = ({ info, files, setFiles, onBack, onDone }) => {
  const [hp, setHp] = useState('');
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const set = (k) => (f) => { setFiles((p) => ({ ...p, [k]: f })); setError(''); };

  const submit = async () => {
    if (!files.ic_front || !files.ic_back) {
      setError('Please upload IC Front and IC Back.');
      return;
    }
    const fd = new FormData();
    fd.append('name', info.name);
    fd.append('id_number', info.id);
    fd.append('website', hp);
    Object.entries(files).forEach(([k, f]) => fd.append(k, f, f.name));
    setSending(true);
    setError('');
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/kyc/submit`, { method: 'POST', body: fd });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.detail || 'Submission failed. Please try again.');
      onDone();
    } catch (e) {
      setError(typeof e.message === 'string' ? e.message : 'Submission failed. Please try again.');
    } finally {
      setSending(false);
    }
  };

  return (
    <section data-testid="kyc-step-2" className="pt-10">
      <h2 className="text-center font-bold text-xl sm:text-[25px]">Tips for scanning</h2>
      <p className="text-center text-[14px] sm:text-[15px] mt-2 max-w-[320px] mx-auto">Find a well-lit place to capture your ID, and do not cover it with anything.</p>

      <div className="grid grid-cols-3 gap-3 sm:gap-5 mt-6 max-w-[520px] mx-auto" data-testid="kyc-tips">
        {TIPS.map((t) => <TipCard key={t.img} {...t} />)}
      </div>

      <div className="flex justify-center gap-5 mt-6">
        <KycUploadButton label="IC FRONT" file={files.ic_front} onChange={set('ic_front')} testId="kyc-ic-front" />
        <KycUploadButton label="IC BACK" file={files.ic_back} onChange={set('ic_back')} testId="kyc-ic-back" />
      </div>


      <input type="text" name="website" value={hp} onChange={(e) => setHp(e.target.value)} tabIndex={-1} autoComplete="off" className="hidden" aria-hidden="true" />

      {error && <p className="text-center text-[13px] text-[#E3473B] mt-8" data-testid="kyc-step2-error">{error}</p>}

      <div className="flex flex-col items-center mt-10 gap-3">
        <button
          type="button"
          onClick={submit}
          disabled={sending}
          className="w-[156px] h-[34px] rounded-[4px] bg-[#F7843A] hover:bg-[#EF7300] disabled:opacity-70 text-[#1a1a1a] font-bold text-[13px] tracking-[0.25em] flex items-center justify-center active:scale-[0.98] transition-[background-color,transform]"
          data-testid="kyc-submit-button"
        >
          {sending ? <Loader2 className="w-4 h-4 animate-spin" /> : 'SUBMIT'}
        </button>
        <button type="button" onClick={onBack} disabled={sending} className="text-[12px] text-[#888] underline hover:text-[#EF7300]" data-testid="kyc-back-button">
          Back
        </button>
      </div>
    </section>
  );
};
